import React, { useState, useEffect } from "react";
import PortalReactDOM from "react-dom";
import Toast from "./Toast";
var ToastPortal = props => {
  var [toastElement, setElement] = useState(null);
  useEffect(() => {
    var toastContainerId = "construct-kit-toast-container";
    var element = document.getElementById(toastContainerId);
    if (!element) {
      element = document.createElement("div");
      element.setAttribute("id", toastContainerId);
      element.setAttribute("class", "");
      document.body.appendChild(element);
    }
    setElement(element);
  }, []);
  if (!toastElement) {
    return null;
  }
  return /*#__PURE__*/PortalReactDOM.createPortal(/*#__PURE__*/React.createElement(Toast, props), toastElement);
};
export default ToastPortal;